import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { Order } from 'ish-core/models/order/order.model';
import { InfoBoxComponent } from 'ish-shared/components/common/info-box/info-box.component';
import { OrderListComponent } from 'ish-shared/components/order/order-list/order-list.component';

/**
 * The Order Widget Component - displays an overview of the latest orders as list.
 *
 * @example
 * <ish-order-widget></ish-order-widget>
 */
@Component({
  selector: 'ish-order-widget',
  templateUrl: './order-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InfoBoxComponent, OrderListComponent, RouterLink, AsyncPipe, TranslateModule],
})
export class OrderWidgetComponent implements OnInit {
  private accountFacade = inject(AccountFacade);

  orders$: Observable<Order[]>;
  ordersLoading$: Observable<boolean>;

  ngOnInit(): void {
    this.orders$ = this.accountFacade.orders$;
    this.ordersLoading$ = this.accountFacade.ordersLoading$;
    // this.accountFacade.loadOrders({ limit: 5 });
    this.accountFacade.customOrders$({ limit: 5 });
  }
}
